import { render } from "./ChefDashboard.vue?vue&type=template&id=8369e416"
import script from "./ChefDashboard.vue?vue&type=script&lang=js"
export * from "./ChefDashboard.vue?vue&type=script&lang=js"

import "./ChefDashboard.vue?vue&type=style&index=0&id=8369e416&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__